import React from "react";
import { TeamOption, TeamsListContainer } from "./style";
import { CheckBox } from "../../components/checkbox";

export const SelectTeams = ({
  allAccessibleTeams,
  selectedTeamIds,
  setSelectedTeamIds,
  checkExtraConditionOnTeamDeSelect
}) => {
  const handleTeamRowClick = id => {
    let newSelectedTeamIds = [...selectedTeamIds];
    if (selectedTeamIds.includes(id)) {
      //deselect/remove
      let can = true;
      if (checkExtraConditionOnTeamDeSelect) {
        can = checkExtraConditionOnTeamDeSelect(id);
      }
      if (can) {
        newSelectedTeamIds = newSelectedTeamIds.filter(teamId => teamId !== id);
      }
    } else {
      //select/add
      newSelectedTeamIds.push(id);
    }
    setSelectedTeamIds(newSelectedTeamIds);
  };
  return (
    <TeamsListContainer>
      {allAccessibleTeams.map(team => (
        <TeamOption key={team.id}>
          <CheckBox
            checked={selectedTeamIds.includes(team.id)}
            onSelect={() => handleTeamRowClick(team.id)}
          />
          <span className="checkbox-title">{team.name}</span>
        </TeamOption>
      ))}
    </TeamsListContainer>
  );
};
